import Admin from "./Default/Admin";

export default Admin;
